// @ts-nocheck
import React, { useEffect, useState } from 'react';
import miniSearch from '../../../lib/scrape-util';

interface Props {
  value: string;
}

const SearchSiteResults: React.FC<Props> = ({ value }) => {
  const data = miniSearch.search(value);

  return (
    <section className="search-site-content-results">
      <h3>Site Content</h3>
      <div>
        {data.length === 0 && (
          <p>
            Your search did not return any matching results. Please try a
            different search.
          </p>
        )}
        <ul>
          {data.map((d, index) => (
            <li key={index} onClick={() => (window.location.href = d.url)}>
              <span>
                <i className="fas fa-arrow-alt-circle-right" />
              </span>
              <span>{d.title}</span>
            </li>
          ))}
        </ul>
      </div>
      {/* language=CSS */}
      <style jsx>{`
        section {
          margin-bottom: 2rem;
        }

        h3 {
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 500;
          margin: 0 0 0.5rem;
        }

        .search-site-content-results :global(p) {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          margin: 0;
        }

        ul {
          list-style: none;
          padding: 0;
        }

        ul li {
          display: flex;
          gap: 1rem;
          margin-bottom: 0.5rem;
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          cursor: pointer;
          padding: 1rem;
        }

        ul li:hover {
          background-color: #eee;
          transition: background-color 0.2s linear;
        }

        ul li span {
          display: block;
        }
      `}</style>
    </section>
  );
};

export default SearchSiteResults;
